module.exports = __webpack_public_path__ + "static/img/product-ekegel.19d80c75.png";